module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp1_4.71922fa3.png";